import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
  getPageInfoInitActions,
} from './common';
import { getAboutSectionWidgetConfigs } from '../../components/Sections/AboutSection/aboutSectionWidgetConfigs';

export function getAboutSectionInitActions(responseData) {
  return getCommonSectionInitActions(responseData, {}, 'about').filter(
    action => action
  );
}

export const getCustomInitActionsForAboutWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getAboutSectionWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getPageInfoInitActions(responseData, requestParams),
];
